import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './toolbar.styles';
interface ToolbarProps {
  children: ComponentChildren;
}

/**
 * The filter bar between a `PageHeader` and the table it filters (R-304).
 *
 * Wrap each control in a `ToolbarItem` — that is what stops a `Select`'s
 * `width: 100%` from resolving against the whole bar and wrapping every sibling
 * onto its own line.
 */
export function Toolbar({
  children
}: ToolbarProps) {
  return <div {...stylex.props(styles.bar)}>{children}</div>;
}
interface ToolbarItemProps {
  /** `md` (200px) suits a state/enum picker; `lg` one whose values are long
   *  (a location, a class); `xl` a search field, matching `Search`'s own cap;
   *  `sm` a switch and its label.
   *
   *  `auto` is for content that ALREADY has an intrinsic width — a row count, a
   *  `Button`. Those need no wrapper at all unless they also want `end`, which is
   *  why the option exists: a fixed box just to push a short count right would
   *  leave it floating in its own gutter. */
  width?: 'auto' | 'sm' | 'md' | 'lg' | 'xl';
  /** Push this item, and everything after it, to the far end of the bar. */
  end?: boolean;
  children: ComponentChildren;
}
export function ToolbarItem({
  width = 'md',
  end = false,
  children
}: ToolbarItemProps) {
  return <div {...stylex.props(styles.item, styles[width], end && styles.end)}>{children}</div>;
}